module.exports = __webpack_public_path__ + "img/daidai3.6ca992ce.png";